"use strict";

require("core-js/modules/es.array.reduce.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AaCalendarUtilities = void 0;

var _dateFns = require("date-fns");
/* eslint-disable consistent-return */


var MILLISECONDS_PER_DAY = 1000 * 60 * 60 * 24;
var dateFormat;
var currencyFormat;
/**
 *
 * @param {number} n - number to check
 *
 * Check for the `n` place value
 */

var log10 = function log10(n) {
  return Math.round(100 * Math.log(n) / Math.log(10)) / 100;
};

var AaCalendarUtilities = {
  setDateFormat: function setDateFormat(format) {
    dateFormat = format;
  },
  setCurrencyFormat: function setCurrencyFormat(format) {
    currencyFormat = format;
  },

  /**
   * @param {Date} date - Date Object
   * @param {number} toAdd - number of months to be added in `date`
   *
   * Add certain number of months to date
   */
  addMonthToDate: function addMonthToDate(date, toAdd) {
    // eslint-disable-next-line consistent-return
    return new Date(date.getFullYear(), date.getMonth() + toAdd, 1);
  },

  /**
   * @param {Date} d - Date Object
   *
   * Returns a `yyyy-mm-dd` date string format that will be use
   * in calendar endpoint
   */
  datePayloadFormat: function datePayloadFormat(d) {
    if (!d) {
      return '';
    }

    var _ref = '',
        month = _ref.month,
        date = _ref.date,
        finalMonth = _ref.finalMonth;
    finalMonth = d.getMonth() + 1;
    date = d.getDate() > 9 ? d.getDate() : "0".concat(d.getDate());
    month = finalMonth > 9 ? finalMonth : "0".concat(finalMonth);
    return "".concat(d.getFullYear(), "-").concat(month, "-").concat(date);
  },

  /**
   * @param {Date} date - Date Object
   * @param {number} toAdd - number of days to be added in `date`
   *
   * Add certain number of days to date
   */
  addDaysToDate: function addDaysToDate(date, toAdd) {
    // eslint-disable-next-line consistent-return
    return new Date(new Date(date).setDate(date.getDate() + toAdd));
  },

  /**
   * @param {Date} date - Date Object
   * @param {number} toSubtract - number of days to be subtracted from `date`
   *
   * Subtract number of days from date
   */
  subtractDaysToDate: function subtractDaysToDate(date, toSubtract) {
    // eslint-disable-next-line consistent-return
    return new Date(new Date(date).setDate(date.getDate() - toSubtract));
  },

  /**
   * @param {Date} date - Date Object
   * @param {number} toSubtract - number of months to be subtracted from `date`
   *
   * Subtract number of months from date
   */
  subtractMonthToDate: function subtractMonthToDate(date, toSubtract) {
    // eslint-disable-next-line consistent-return
    return new Date(new Date(date).setMonth(date.getMonth() - toSubtract));
  },

  /**
   * @param {Date} date1 - Date Object
   * @param {Date} date2 - Date Object
   *
   * Compares if dates are the same
   */
  checkIfDateAreSame: function checkIfDateAreSame(date1, date2) {
    // eslint-disable-next-line consistent-return
    return date1.setHours(0, 0, 0, 0) === date2.setHours(0, 0, 0, 0);
  },

  /**
   * @param {Date} checkDate - Date Object
   * @param {Date} startDate - Date Object
   *
   * Check if `checkDate` is ahead/greater or equal to `startDate`
   */
  checkIfDateIsAheadOrEqualOfStartDate: function checkIfDateIsAheadOrEqualOfStartDate(checkDate, startDate) {
    if (startDate == null) return null;
    return checkDate.setHours(0, 0, 0, 0) >= startDate.setHours(0, 0, 0, 0);
  },

  /**
   * @param {Date} checkDate - Date Object
   * @param {Date} startDate - Date Object
   *
   * Check if `checkDate` is ahead/greater than `startDate`
   */
  checkIfDateIsAheadOfStartDate: function checkIfDateIsAheadOfStartDate(checkDate, startDate) {
    if (startDate == null) return null;
    return checkDate.setHours(0, 0, 0, 0) > startDate.setHours(0, 0, 0, 0);
  },

  /**
   * @param {Date} startDate - Date Object
   *
   * Check if `start date` is in the same month as the current month
   */
  isDateInCurrentMonth: function isDateInCurrentMonth(startDate) {
    return AaCalendarUtilities.checkIfDateIsAheadOrEqualOfStartDate(new Date(), startDate);
  },

  /**
   * @param {Date} checkDate - Date Object
   * @param {Date} startDate - Date Object
   *
   * Check if `checkDate` is less than `startDate`
   */
  checkIfDateIsPreviousOfStartDate: function checkIfDateIsPreviousOfStartDate(checkDate, startDate) {
    return checkDate.setHours(0, 0, 0, 0) < startDate.setHours(0, 0, 0, 0);
  },

  /**
   * @param {Date} checkDate - Date Object
   * @param {Date} startDate - Date Object
   *
   * Check if `checkDate` is less than or equal to `startDate`
   */
  checkIfDateIsPreviousOrEqualOfStartDate: function checkIfDateIsPreviousOrEqualOfStartDate(checkDate, startDate) {
    return checkDate.setHours(0, 0, 0, 0) <= startDate.setHours(0, 0, 0, 0);
  },

  /**
   * @param {Date} checkDate - Date Object
   * @param {Date} startDate - Date Object
   * @param {Date} endDate - Date Object
   *
   * Check if `checkDate` is greater than or equal to `startDate` and less than or equal to `endDate`
   */
  checkifDateBeyondRange: function checkifDateBeyondRange(checkDate, startDate, endDate) {
    if (!checkDate || !startDate || !endDate) {
      return;
    }

    return checkDate.setHours(0, 0, 0, 0) <= startDate.setHours(0, 0, 0, 0) || checkDate.setHours(0, 0, 0, 0) >= endDate.setHours(0, 0, 0, 0);
  },

  /**
   * @param {Date} d1 - Date Object
   * @param {Date} d2 - Date Object
   *
   * Returns the difference of `d2` and `d1` in terms of years
   */
  yearsDifference: function yearsDifference(d1, d2) {
    var date1 = new Date(d1);
    var date2 = new Date(d2);
    var yearsDiff = date2.getFullYear() - date1.getFullYear();
    return yearsDiff;
  },

  /**
   * @param {Date} d1 - Date Object
   * @param {Date} d2 - Date Object
   *
   * Returns the difference of `d2` and `d1` in terms of months
   */
  monthsDifference: function monthsDifference(d1, d2) {
    var date1 = new Date(d1);
    var date2 = new Date(d2);
    var years = AaCalendarUtilities.yearsDifference(d1, d2);
    var months = years * 12 + (date2.getMonth() - date1.getMonth());
    return months;
  },

  /**
   * @param {Date} date1 - Date Object
   * @param {Date} date2 - Date Object
   *
   * Returns the difference of `d2` and `d1` in terms of days
   */
  dayDifference: function dayDifference(date1, date2) {
    var timeDiff = date2.getTime() - date1.getTime();
    var diffDays = Math.ceil(timeDiff / MILLISECONDS_PER_DAY);
    return diffDays;
  },

  /**
   * @param {string} d - date string
   * @param {string} format - date format
   *
   * Returns a formatted date string based on `format` date format
   */
  formatDates: function formatDates(d) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dd/MM/yyyy';

    if (!Date.parse(d)) {
      return null;
    }

    if (format === 'dd/MM/yyyy' && dateFormat && dateFormat.date && dateFormat.date.general !== 'dd/mm/yyyy') {
      // eslint-disable-next-line no-param-reassign
      format = dateFormat.date.general;
    }

    var newFormat = format.replace(new RegExp('m', 'g'), 'M');
    return (0, _dateFns.format)(d, newFormat);
  },
  convertToDate: function convertToDate(dateString) {
    //  Convert a "dd/MM/yyyy" string into a Date object
    var d = dateString.split('/');
    var dat = new Date("".concat(d[2], "/").concat(d[1], "/").concat(d[0]));
    return dat;
  },
  getV2priceList: function getV2priceList(priceArr) {
    return priceArr && priceArr.reduce( // eslint-disable-next-line no-return-assign
    function (obj, item) {
      return obj[AaCalendarUtilities.formatDates(AaCalendarUtilities.convertToDate(item.departureDate), 'yyyy-MM-dd')] = // eslint-disable-next-line no-sequences
      item.shortPrice ? item.shortPrice : item.price, obj;
    }, {});
  },

  /**
   * @param {Date} date - Date Object
   *
   * Returns formatted date string that will be used as Calendar Label
   * for each calendar instance
   */
  setNoDayFormat: function setNoDayFormat(date) {
    var dateArray = AaCalendarUtilities.formatDates(date, dateFormat.date.noDay).split(' ');

    if (!dateFormat.fullMonthTranslation[dateArray[0].toLowerCase()]) {
      return dateArray[0];
    }

    dateArray[0] = dateFormat.fullMonthTranslation[dateArray[0].toLowerCase()]; // dateArray[0]={apr: "April",aug: "August",dec: "December",feb: "February",jan: "January",jul: "July",
    // jun: "June",mar: "March",may: "May",nov: "November",oct: "October",sep: "September"}[dateArray[0].toLowerCase()];

    var newDate = dateArray.join(' ');
    return newDate;
  },

  /**
   * @param {string} value - value to be formatted
   *
   * Returns a date string formatted to `mm/dd/yyyy`.
   * This is used in formatting the inputted date in depart/return text fields
   */
  formatDateInputFormat: function formatDateInputFormat(value) {
    var strArray = value.split(/[^0-9]/);
    var dateFormatArray = dateFormat.date.general.toLowerCase().split(/[^a-zA-Z]/);
    var indexOfMonth = dateFormatArray.indexOf('mm');
    var indexOfDate = dateFormatArray.indexOf('dd');
    var indexOfYear = dateFormatArray.indexOf('yyyy');
    var formattedDate = "".concat(strArray[indexOfMonth], "/").concat(strArray[indexOfDate], "/").concat(strArray[indexOfYear]);

    if (!Date.parse(formattedDate)) {
      return null;
    }

    return formattedDate;
  },

  /**
   * @param {number} value - price to be converted
   * @param {number} exchangeRate - exchange rate to be used
   *
   * Returns the converted price based on `exchangeRate`.
   * Can be use to calculate exchange rate
   */
  exchangeRateConverter: function exchangeRateConverter(value, exchangeRate) {
    if (value === undefined || value === null) {
      return 0;
    }

    var valueHolder = value;
    valueHolder *= exchangeRate;
    return valueHolder;
  },

  /**
   * @param {number} num - number to be formatted
   * @param {number} fixed - number of decimals to fix
   *
   * Fixed the value of `num` to certain number of decimals `fixed`
   */
  toFixed: function toFixed(num, fixed) {
    if (num === null || num === undefined) {
      return;
    }

    if (fixed === null || fixed === undefined) {
      return num;
    }

    var re = new RegExp("^-?\\d+(?:.\\d{0,".concat(fixed || -1, "})?"));

    if (!num.toString().match(re)) {
      return num;
    }

    return num.toString().match(re)[0];
  },

  /**
   * @param {number} value - value to be formatted
   * @param {number} decimal - number of decimals to fix
   *
   * Returns a fixed formatted `value` based on `decimal`
   */
  currencyFormatter: function currencyFormatter(value, decimal) {
    if (value === undefined || value === null) {
      return;
    }

    var currencyDecimal = 2; // default to 2.

    if (decimal !== undefined || decimal != null) {
      currencyDecimal = decimal;
    } // let formatedCurrency = Number(parseFloat(value).toFixed(currencyDecimal));


    var formatedCurrency = Number(AaCalendarUtilities.toFixed(parseFloat(value), currencyDecimal));

    if (Number.isNaN(formatedCurrency)) {
      return ' ';
    }

    return formatedCurrency;
  },

  /**
   * @param {number} value - number to be checked
   *
   * Checks if `value` place value is thousands.
   * Used in price formatting based on currency selected
   */
  isValueThousands: function isValueThousands(value) {
    return log10(value) >= 3 && log10(value) < 6;
  },

  /**
   * @param {number} value - number to be checked
   *
   * Checks if `value` place value is millions
   * Used in price formatting based on currency selected
   */
  isValueMillions: function isValueMillions(value) {
    return log10(value) >= 6;
  },
  formatString: function formatString(source, params) {
    var formattedSource = source;
    params.forEach(function (n, i) {
      formattedSource = formattedSource.replace(new RegExp("\\{".concat(i, "\\}"), 'g'), n);
    });
    return formattedSource;
  },

  /**
   * @param {number | string} value - price to be formatted
   * @param {Object} currency - currency object
   *
   * Returns a price formatted string based on currency selected.
   * Used to format prices found below each date item in the calendar
   */
  currencySymbolFormatter: function currencySymbolFormatter(value, currency) {
    if (value === undefined || value === null) {
      return;
    }

    if (Number.isNaN(value)) {
      return;
    }

    if (value === 0 || value === ' ' || value === '') {
      return;
    }

    if (!currency) {
      return;
    }

    if (!currencyFormat) {
      return;
    } // if(!currencyFormat[currency.collectedCurrency.toUpperCase()]){
    //     return ' ';
    // }
    // return value;


    var currencyData = currencyFormat[currency.toUpperCase()]; // const currencySymbol = currencyData ? currencyData.shortSymbol : '';

    var decimalThousand = currencyData ? currencyData.shortDecimalThousand || 0 : 1;
    var decimalMillion = currencyData ? currencyData.shortDecimalMillion || 0 : 2;
    var price = value;
    var abbreviationSymbol = '';
    var formattedPrice = '';

    if (AaCalendarUtilities.isValueThousands(price)) {
      var p = price / 1e3;
      price = AaCalendarUtilities.currencyFormatter(p, decimalThousand);
      abbreviationSymbol = currencyFormat.abbreviation.thousand;
    } else if (AaCalendarUtilities.isValueMillions(price)) {
      var _p = price / 1e6;

      price = AaCalendarUtilities.currencyFormatter(_p, decimalMillion);
      abbreviationSymbol = currencyFormat.abbreviation.million;
    } else {
      price = AaCalendarUtilities.currencyFormatter(price, 0);
    }

    if (currencyData && currencyData.shortFormat) {
      // formattedPrice = currencyData.shortFormat.replace(/s/g, currencySymbol).replace(/v/g, price);
      formattedPrice = currencyData.shortFormat.replace(/s/g, '').replace(/v/g, price);
    } else {
      // formattedPrice = `${currencySymbol}${price}`;
      formattedPrice = "".concat(price);
    }

    formattedPrice = "".concat(formattedPrice).concat(abbreviationSymbol);
    return formattedPrice;
  },
  isValidDate: function isValidDate(dateString) {
    return dateString && Boolean(Date.parse(dateString));
  },
  convertStringToNumber: function convertStringToNumber(num) {
    if (num === undefined || num === null) {
      return;
    }

    if (num === 0 || num === ' ' || num === '') {
      return;
    }

    var multiplier = num.substr(-1).toLowerCase();
    if (multiplier === 'k') return parseFloat(num) * 1000;
    if (multiplier === 'm') return parseFloat(num) * 1000000;
    return num;
  },
  isPriceLessThanSelectedPrice: function isPriceLessThanSelectedPrice(price, selectedPrice) {
    return AaCalendarUtilities.convertStringToNumber(price) < AaCalendarUtilities.convertStringToNumber(selectedPrice);
  },
  isInViewport: function isInViewport(el) {
    var rect = el.getBoundingClientRect();
    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
  }
};
exports.AaCalendarUtilities = AaCalendarUtilities;